import { FaceSmileIcon } from '@heroicons/react/24/outline';
import EmojiPicker from 'emoji-picker-react';
import { useRef, useState } from 'react';
import { Button, Tooltip } from 'react-daisyui';
import useEmojiAction from './EmojiAction.hooks.tsx';
import './EmojiAction.styles.scss';

export default function EmojiAction({
  isLegacyEditor,
}: {
  isLegacyEditor?: boolean;
}) {
  const emojiButtonRef = useRef<HTMLButtonElement>(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState<boolean>(false);
  const { addEmojiToMessage, emojiPickerTheme } = useEmojiAction({
    emojiButtonRef,
    showEmojiPicker,
    setShowEmojiPicker,
  });

  const pickerStyles = !isLegacyEditor ? { left: 0, bottom: 75 } : {};

  return (
    <>
      <Tooltip message="Emojis">
        <Button
          size="xs"
          color="ghost"
          ref={emojiButtonRef}
          onClick={() => setShowEmojiPicker(!showEmojiPicker)}
          className="MessageBar__Button"
        >
          <FaceSmileIcon className="MessageBar__Icon" />
        </Button>
      </Tooltip>

      {showEmojiPicker && (
        <EmojiPicker
          autoFocusSearch
          lazyLoadEmojis
          theme={emojiPickerTheme}
          open={true}
          width={300}
          height={400}
          style={{
            zIndex: 9999,
            ...pickerStyles,
          }}
          onEmojiClick={addEmojiToMessage}
        />
      )}
    </>
  );
}
